import React from 'react'

const CCNotification = () => {
  return (
    <div>CCNotification</div>
  )
}

export default CCNotification